import { unwrap } from "@nexxt/api-client";
import { forgetPushDevice } from "@nexxt/app-kit";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { auth } from "../../api";
import { bellClient } from "../../bell-client";

/** The signed-in user with roles and permissions (identity `getMe`): the menus and actions follow it. */
export const meQuery = queryOptions({
  queryKey: ["me"],
  queryFn: () => unwrap(auth.me.$get()),
  staleTime: 5 * 60_000,
});

export function useMe() {
  return useSuspenseQuery(meQuery).data;
}

/** Tomorrow's users (the internal organization): the rules on who does what distinguish them (catalog.md §1). */
export function useIsInternal(): boolean {
  return useMe().organization.type === "internal";
}

/** Hides what the user cannot do; the gateway and the domain check again (ADR-014). */
export function useCan(permission: string): boolean {
  return useMe().permissions.includes(permission);
}

/** This browser stops receiving the person's pushes first (ADR-283): the next person in it gets none of theirs. */
export async function signOut(): Promise<void> {
  await forgetPushDevice(bellClient.push);
  const { logoutUrl } = await unwrap(auth.logout.$post());
  location.assign(logoutUrl);
}
